import { mapGetters } from 'vuex';
import { range } from 'lodash';
import loaderMixin from '@/mixins/loader';
import contentLoaderMixin from '@/mixins/contentLoader';
import overviewMapContract from '@/components/pages/page-election-map-new/overview-map/overview-map-contract/overview-map-contract.vue';

export default {
  mixins: [
    contentLoaderMixin,
    loaderMixin,
  ],
  components: {
    overviewMapContract,
  },
  props: {
    mapOverviewData: {},
    type: {
      type: String,
      default: 'electoral',
    },
  },
  computed: {
    ...mapGetters('app', ['isLayoutMobile', 'isLayoutDesktop']),
    num() {
      return 2;
    },
    dummyComponents() {
      return range(0, this.num);
    },
    items() {
      return this.mapOverviewData.slice(0, this.num);
    },
  },
  methods: {
    mapOverviewDataHandler(value) {
      if (value.length > 0) {
        this.isComponentReady = true;
      }
    },
  },
  watch: {
    mapOverviewData: {
      handler: 'mapOverviewDataHandler',
      immediate: true,
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-election-map-new/overview-map/overview-map.js